import gql from 'graphql-tag';

/**
 * Parent-link fragments for reading a row's ancestors out of the normalized Apollo cache.
 *
 * One field per level, so a null read means "this row's parent was never fetched" rather than
 * "some unrelated field is absent".
 */

export const AD_PARENT_FRAGMENT = gql`
  fragment adParent on AdV5 {
    lineItem {
      id
    }
  }
`;

export const LINE_ITEM_PARENT_FRAGMENT = gql`
  fragment lineItemParent on LineItemV5 {
    campaign {
      id
    }
  }
`;
